module.exports = __webpack_public_path__ + "media/images/home-large2x-95464ba955fc24ee2bbfa20da2f31127.jpg";